import React from 'react';
import { MdPlace } from 'react-icons/md';

export default function ContactInfoItems({
  icon = <MdPlace />,
  text = 'This is an info',

}) {
  return (
    <div className='lg:w-auto md:w-1/3 mx-3 gap-2 text-white flex border-4 rounded-2xl border-indigo-200 py-2 px-2 mb-7 '>
      <div className='icon '>{icon}</div>
      <div className='info'>
        <p>{text}</p>
      </div>
    </div>
  )
}

